import { render, staticRenderFns } from "./QuestionCatalogSelector.vue?vue&type=template&id=07f6a1f6&"
import script from "./QuestionCatalogSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionCatalogSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports